import { createContext, useContext } from "react";

export const NotificationContext = createContext();

export function useNotify() {
  return useContext(NotificationContext);
}
